<template>
  <div v-show="dialogVisible" class="oms-dialog-wrapper">
    <div v-loading="loading" class="oms-dialog">
      <div class="oms-dialog-body">
        <el-form ref="form" class="form" :model="form" :rules="rules">
          <!-- <el-form-item prop="type" label="费用类型">
            <el-select
              v-model="form.type"
              style="width: 100%"
              placeholder="请选择"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item prop="feeTypeId" label="费用大类">
            <el-select
              v-model="form.feeTypeId"
              style="width: 100%"
              placeholder="请选择"
            >
              <el-option
                v-for="item in feeTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="feeNameId" label="费用细类">
            <el-select
              v-model="form.feeNameId"
              style="width: 100%"
              placeholder="请选择"
            >
              <el-option
                v-for="item in feeNameList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="amount" label="金额">
            <el-input-number
              v-model="form.amount"
              style="width: 100%"
              controls-position="right"
              :min="0.01"
              :precision="2"
              :step="1"
            >
            </el-input-number>
          </el-form-item></el-form>
      </div>
      <div class="oms-dialog-footer">
        <div class="btn cancel" @click="cancel('form')">取 消</div>
        <div class="btn ok" @click="ok('form')">确 定</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getFeeTypeList, getFeeNamePageList, saveArApTemplate } from '@/api/fee'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    summaryId: {
      type: String,
      default: ''
    },
    tplType: {
      type: Number,
      default: 0 // 0 客户 应收 1 供应商 应付
    }
  },
  data() {
    return {
      form: {
        // type: '',
        feeNameId: '',
        feeTypeId: '',
        amount: ''
      },
      rules: {
        // type: [{ required: true, message: '请选择费用类型', trigger: 'change' }],
        feeNameId: [{ required: true, message: '请选择费用大类', trigger: 'change' }],
        feeTypeId: [{ required: true, message: '请选择费用系列', trigger: 'change' }],
        amount: [{ required: true, message: '请选择金额', trigger: 'blur' }]
      },
      feeTypeOptions: [],
      feeTypeOptions2: [],
      typeOptions: [
        {
          value: 0,
          label: '应收'
        },
        {
          value: 1,
          label: '应付'
        }
      ],
      loading: false
    }
  },
  computed: {

    feeNameList() {
      const arr = this.feeTypeOptions2.filter(a => this.form.feeTypeId === a.feeTypeId && a.isTemplate)
      return arr
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.form = {
          ...this.rowData,
          feeNameId: +this.rowData?.feeNameId || '',
          feeTypeId: +this.rowData?.feeTypeId || ''
        }
        this.getFeeTypeList()
      }
    }
  },
  methods: {
    cancel() {
      this.$refs['form'].resetFields()
      this.$emit('cancel')
    },
    async getFeeTypeList() {
      try {
        const res = await getFeeTypeList()
        if (res.success) {
          const arr = []
          res.data &&
            res.data.map((item) => {
              arr.push({
                value: item.id,
                label: item.name
              })
            })
          this.feeTypeOptions = arr
          const promise = res.data.map(async(item) => {
            const params = {
              pageIndex: 1,
              pageSize: 1000,
              queryParam: {
                feeTypeId: item.id,
                search: '',
                isActived: '',
                isVisible: true
              }
            }
            let result
            try {
              result = await getFeeNamePageList(params)
            } catch (error) {
              console.error(error)
            }
            return new Promise((resolve) => {
              resolve(result)
            })
          })
          Promise.all(promise).then((res) => {
            const arr = []
            res.forEach((item) => {
              item.data.list.forEach((dataItem) => {
                arr.push({
                  ...dataItem,
                  value: dataItem.id,
                  label: dataItem.name
                })
              })
            })
            this.feeTypeOptions2 = arr
          })
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          // this.$emit('ok', { userId: this.form.userId })
          try {
            const res = await saveArApTemplate({
              ...this.form,
              type: this.tplType,
              summaryId: this.summaryId
            })
            if (res.success) {
              this.$emit('ok')
              this.$refs['form'].resetFields()
              this.$message.success('保存成功')
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.error(error)
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.oms-dialog-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  margin: 0;
  width: 740px;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0px 0px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  .oms-dialog {
    width: 360px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    padding: 20px;
    margin: 0 auto;
  }
  .oms-dialog-header {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    .title {
      height: 40px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 40px;
    }
    .close {
      font-size: 20px;
      color: #999999;
      cursor: pointer;
      line-height: 40px;
    }
  }
  .oms-dialog-body {
    width: 100%;
  }
  .oms-dialog-footer {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    .btn {
      width: 80px;
      height: 40px;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      text-align: center;
      cursor: pointer;
      & + .btn {
        margin-left: 10px;
      }
    }
    .cancel {
      background: #eeeeee;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
    }
    .ok {
      background: rgb(18, 88, 188);
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
    }
  }
}
</style>
